module.exports = __webpack_public_path__ + "48c9bab8534d638077f24b367536562c.pdf";